import HasPermissions from './HasPermissions';

const CanUpdate = service => Component => HasPermissions(service.getUpdatePermissions())(Component);

export default CanUpdate;



// WEBPACK FOOTER //
// ./src/components/cms/permissions/CanUpdate.js